module.exports = __webpack_public_path__ + "img/businessOne.8cc608be.svg";